interface ScreenInfo {
  // 基本信息
  width: number
  height: number
  availWidth: number
  availHeight: number
  pixelRatio: number
  colorDepth: number
  orientation: string
  touchPoints: number

  // 扩展信息
  aspectRatio: string
  scaleFactor: number
  isRetina: boolean
  isTouch: boolean
  isLandscape: boolean
}

function calculateAspectRatio(width: number, height: number): string {
  const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b))
  const divisor = gcd(width, height)
  return `${width / divisor}:${height / divisor}`
}

export function getScreenFingerprint(): ScreenInfo {
  const screen = window.screen
  const orientation = screen.orientation || {}

  return {
    // 基本信息
    width: screen.width,
    height: screen.height,
    availWidth: screen.availWidth,
    availHeight: screen.availHeight,
    pixelRatio: window.devicePixelRatio || 1,
    colorDepth: screen.colorDepth,
    orientation: orientation.type || 'unknown',
    touchPoints: navigator.maxTouchPoints || 0,

    // 计算的信息
    aspectRatio: calculateAspectRatio(screen.width, screen.height),
    scaleFactor: screen.width / screen.availWidth || 1,
    isRetina: (window.devicePixelRatio || 1) > 1,
    isTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    isLandscape: screen.width > screen.height
  }
}
